import { ClassNameProps, Row, StyleProps } from "@hex-insights/core";
import { Badge } from "../../../../Components/Badge";
import { Icon } from "../../../../Components/Icon";
import { Contract } from "../../../../Utilities";
import { ContractFormat } from "../../../Format";
import { ContractUtilities } from "../../../Utilities";

const contractStatusColors = {
	[ContractUtilities.ContractStatus.Active]: {
		color: "var(--brand-colors--primary)",
		backgroundColor: "var(--brand-colors--primary--light)",
	},
	[ContractUtilities.ContractStatus.Approved]: {
		color: "var(--theme-colors__green--dark)",
		backgroundColor: "var(--theme-colors__green--very-light)",
	},
	[ContractUtilities.ContractStatus.Void]: {
		color: "var(--theme-colors__orange--dark)",
		backgroundColor: "var(--theme-colors__orange--very-light)",
	},
	[ContractUtilities.ContractStatus.Draft]: {
		color: "var(--neutral-colors--tertiary)",
		backgroundColor: "var(--neutral-colors--light)",
	},
};

export type ContractStatusBadgeProps = {
	status: Contract["status"];
	withIcon?: boolean;
} & Partial<ClassNameProps & StyleProps>;

export function ContractStatusBadge({ status, withIcon = false, className, style }: ContractStatusBadgeProps) {
	const colors = contractStatusColors[status];

	return (
		<Badge color={colors?.color} backgroundColor={colors?.backgroundColor} className={className} style={style}>
			<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem">
				{withIcon && <ContractStatusIcon status={status} size={14} color={colors.color} />}
				{ContractFormat.Fields.status(status)}
			</Row>
		</Badge>
	);
}

export type ContractStatusIconProps = Icon.IconProps & {
	status: Contract["status"];
};

export function ContractStatusIcon({ status, color, ...props }: ContractStatusIconProps) {
	color = color ?? contractStatusColors[status].color;

	switch (status) {
		case ContractUtilities.ContractStatus.Active:
			return <Icon.Check color={color} {...props} />;
		case ContractUtilities.ContractStatus.Approved:
			return <Icon.Check color={color} {...props} />;
		case ContractUtilities.ContractStatus.Void:
			return <Icon.X color={color} {...props} />;
		case ContractUtilities.ContractStatus.Draft:
			return <Icon.NotePencil color={color} {...props} />;
		default:
			return null;
	}
}
